/**
 * to generate patient basic details
 * @param {*} details 
 */

import { getStorage } from "../../../../utilities/browserStorage";
import i18n from "../../../../utilities/i18n";
import { DEFAULT_ASSIGNMENT_OF_BENEFITS, SSN_VALID_LENGTH, SSN_VALID_LENGTH_SMALL } from "../../../../utilities/staticConfigs";
import { format } from 'date-fns';

export const generatePatientBasicDetails = (patientInfoDetails, permittedField) => {
    let patient_basic_details = {};
    patient_basic_details = {
        ...patientInfoDetails,
        custom_patient_id: patientInfoDetails.custom_patient_id, 
        date_of_birth: patientInfoDetails?.date_of_birth
            ? new Date(patientInfoDetails?.date_of_birth + " 00:00:00")
            : null,
        date_of_death: patientInfoDetails?.date_of_death
            ? new Date(patientInfoDetails?.date_of_death + " 00:00:00")
            : null,
        detail_ids: patientInfoDetails.detail_ids,
        first_name: patientInfoDetails.first_name ?? null,
        gender: patientInfoDetails.gender ?? null,
        last_name: patientInfoDetails.last_name ?? null,
        locked_by_name:
            patientInfoDetails.locked &&
                patientInfoDetails.locked_by ===
                JSON.parse(getStorage("userData")).profile_id
                ? i18n.t("commons.self")
                : patientInfoDetails.locked_by_name,
        locked: patientInfoDetails.locked,
        middle_name: patientInfoDetails.middle_name ?? null,
        active: patientInfoDetails.active,
        patient_editable:
            patientInfoDetails.active &&
                (!patientInfoDetails.locked ||
                    (patientInfoDetails.locked &&
                        patientInfoDetails.locked_by ===
                        JSON.parse(getStorage("userData")).profile_id &&
                        patientInfoDetails.unid ===
                        JSON.parse(getStorage("userData")).unid))
                ? true
                : false,
        patient_inactive: patientInfoDetails.active ? false : true,
        patient_type: patientInfoDetails.patient_type ?? null,
        patient: patientInfoDetails.id ?? null,
        profile_locked:
            patientInfoDetails.locked &&
                patientInfoDetails.locked_by !==
                JSON.parse(getStorage("userData")).profile_id &&
                patientInfoDetails.unid !== JSON.parse(getStorage("userData")).unid
                ? true
                : false,
        ssn: patientInfoDetails.ssn ?? null,
        suffix: patientInfoDetails.suffix ?? null,
        other_id: patientInfoDetails.other_id ?? null,
        permittedFields: {
            patient_basic_fields: permittedField?.patient_basic_fields ?? {}, notes: permittedField?.notes ?? {},
            alert: permittedField?.alerts ?? {}, documents: permittedField?.documents ?? {}
        }
    }
    return patient_basic_details;
}


export const generatePatientInfoData = (patientInfoVariables, relationList, serviceLocations, rrenderingProvider, permittedField, context = {}) => {
    const {
        zip = null,
        city = null,
        state = null,
        DEFAULT_COUNTRY = "USA",
        DEFAULTRELATION = "self",
    } = context;

    let obj = relationList?.find(
        (item) => item.name.toLowerCase() === DEFAULTRELATION.toLowerCase()
    );

    const defProv = rrenderingProvider.find((p) => p.default_provider === true)?.id;
    const defLoc = serviceLocations.find((l) => l.default_location === true)?.id;

    let rendering_provider = defProv || null;
    let service_location_value = defLoc || null;
    let service_location = {};

    if (defLoc) {
        service_location = {
            id: defLoc.split("||")[0],
            location_type: defLoc.split("||")[1],
        }
    }

    let setEmergencySelf = false;
    let setEmergencyRelationShip = "";
    let setGuarantorSelf = false;

    let patientInfoData = {
        ...patientInfoVariables,
        id: patientInfoVariables?.id ?? null,
        active: patientInfoVariables?.active ?? false,
        authorized_contact: patientInfoVariables?.authorized_contact ?? null,
        cell_phone: patientInfoVariables?.cell_phone=="" ? "1" : patientInfoVariables?.cell_phone,
        email: patientInfoVariables?.email ?? "",
        emergency_as_guarantor: patientInfoVariables?.emergency_as_guarantor,
        emergency_cell_phone: patientInfoVariables?.emergency_cell_phone=="" ? "1" : patientInfoVariables?.emergency_cell_phone,
        emergency_email: patientInfoVariables?.emergency_email ?? "",
        emergency_first_name: patientInfoVariables?.emergency_first_name ?? "",
        emergency_home_phone: patientInfoVariables?.emergency_home_phone=="" ? "1" : patientInfoVariables?.emergency_home_phone,
        emergency_last_name: patientInfoVariables?.emergency_last_name ?? "",
        emergency_location: patientInfoVariables?.emergency_location,
        emergency_location_data: patientInfoVariables?.emergency_location_data
            ? {
                street1: patientInfoVariables.emergency_location_data.street1 ?? "",
                street2: patientInfoVariables.emergency_location_data.street2 ?? "",
                zip_code: patientInfoVariables.emergency_location_data.zip_code ?? "",
                city: patientInfoVariables.emergency_location_data.city ?? "",
                state: patientInfoVariables.emergency_location_data.state ?? "",
                country: patientInfoVariables.emergency_location_data.country ?? "",
            }
            : {
                street1: "",
                street2: "",
                zip_code: zip,
                city: city,
                state: state,
                country: DEFAULT_COUNTRY,
            },
        emergency_middle_name: patientInfoVariables?.emergency_middle_name ?? "",
        emergency_relationship: patientInfoVariables?.emergency_relationship ?? obj?.id ?? "",
        emergency_relationship_name: patientInfoVariables?.emergency_relationship_name,
        emergency_suffix: patientInfoVariables?.emergency_suffix ?? "",
        emergency_work_phone: patientInfoVariables?.emergency_work_phone=="" ? "1" : patientInfoVariables?.emergency_work_phone,
        ethnicity: patientInfoVariables?.ethnicity,
        service_location: patientInfoVariables?.service_location_value
            ? {
                id: patientInfoVariables.service_location_value.split("||")[0],
                location_type: patientInfoVariables.service_location_value.split("||")[1],
            }
            : service_location ?? {},
        service_location_value: patientInfoVariables?.service_location_value ?? service_location_value ?? "",
        guarantor_address_as_patient: patientInfoVariables?.guarantor_address_as_patient,
        guarantor_cell_phone: patientInfoVariables?.guarantor_cell_phone=="" ? "1" :  patientInfoVariables?.guarantor_cell_phone,
        guarantor_email: patientInfoVariables?.guarantor_email ?? "",
        guarantor_first_name: patientInfoVariables?.guarantor_first_name ?? "",
        guarantor_home_phone: patientInfoVariables?.guarantor_home_phone=="" ? "1" : patientInfoVariables?.guarantor_home_phone,
        guarantor_last_name: patientInfoVariables?.guarantor_last_name ?? "",
        guarantor_location: patientInfoVariables?.guarantor_location ?? "",
        guarantor_location_data: patientInfoVariables?.guarantor_location_data
            ? {
                street1: patientInfoVariables.guarantor_location_data.street1 ?? "",
                street2: patientInfoVariables.guarantor_location_data.street2 ?? "",
                zip_code: patientInfoVariables.guarantor_location_data.zip_code ?? "",
                city: patientInfoVariables.guarantor_location_data.city ?? "",
                state: patientInfoVariables.guarantor_location_data.state ?? "",
                country: patientInfoVariables.guarantor_location_data.country ?? "",
            }
            : {
                street1: "",
                street2: "",
                zip_code: zip,
                city: city,
                state: state,
                country: DEFAULT_COUNTRY,
            },
        guarantor_middle_name: patientInfoVariables?.guarantor_middle_name ?? "",
        guarantor_relationship: patientInfoVariables?.guarantor_relationship ?? obj?.id ?? "",
        guarantor_relationship_name: patientInfoVariables?.guarantor_relationship_name,
        guarantor_suffix: patientInfoVariables?.guarantor_suffix ?? "",
        guarantor_work_phone: patientInfoVariables?.guarantor_work_phone=="" ? "1" : patientInfoVariables?.guarantor_work_phone,
        home_phone: patientInfoVariables?.home_phone=="" ? "1" : patientInfoVariables?.home_phone,
        location: patientInfoVariables?.location ?? "",
        location_data: patientInfoVariables?.location_data
            ? {
                street1: patientInfoVariables.location_data.street1 ?? "",
                street2: patientInfoVariables.location_data.street2 ?? "",
                zip_code: patientInfoVariables.location_data.zip_code ?? "",
                city: patientInfoVariables.location_data.city ?? "",
                state: patientInfoVariables.location_data.state ?? "",
                country: patientInfoVariables.location_data.country ?? "",
            }
            : {
                street1: "",
                street2: "",
                zip_code: zip,
                city: city,
                state: state,
                country: DEFAULT_COUNTRY,
            },
        patient: patientInfoVariables?.patient ?? "",
        patient_status: patientInfoVariables?.patient_status ?? "",
        preferred_language: patientInfoVariables?.preferred_language ?? "",
        race: patientInfoVariables?.race ?? "",
        referring_provider: patientInfoVariables?.referring_provider ?? "",
        referring_provider_group: patientInfoVariables?.referring_provider_group ?? "",
        rendering_provider: patientInfoVariables?.rendering_provider
            ? patientInfoVariables.rendering_provider
            : rendering_provider ?? null,
        work_phone: patientInfoVariables?.work_phone =="" ? "1" : patientInfoVariables?.work_phone,
        permittedFields: {
            patient_info: permittedField?.patient_info,
            manage_authorization: permittedField?.manage_authorization, insurance_info: permittedField?.insurance_info
        } ?? {}
    };

    if (
        (patientInfoVariables?.guarantor_relationship_name &&
            patientInfoVariables.guarantor_relationship_name.toLowerCase() === DEFAULTRELATION) ||
        !patientInfoVariables?.guarantor_relationship
    ) {
        setGuarantorSelf = true;
    } else {
        setGuarantorSelf = false;
    }

    setEmergencyRelationShip = patientInfoVariables?.emergency_relationship ?? obj?.id;

    if (
        (patientInfoVariables?.emergency_relationship_name &&
            patientInfoVariables.emergency_relationship_name.toLowerCase() === DEFAULTRELATION) ||
        !patientInfoVariables?.emergency_relationship
    ) {
        setEmergencySelf = true;
    } else {
        setEmergencySelf = false;
    }

    let disableGuarantorAddressFields = patientInfoVariables?.guarantor_address_as_patient ?? false

    return {
        patientInfoData,
        setEmergencySelf,
        setEmergencyRelationShip,
        setGuarantorSelf,
        disableGuarantorAddressFields
    };
}


export const generateOtherBillingData = (patientOtherBillingDetails, assignmentList, permittedField) => {
    let data = patientOtherBillingDetails ?? {}
    let patient_other_billing_details = {};
    if (data) {
        let obj = assignmentList.length > 0 && assignmentList.find(
            (item) => item.name.toLowerCase() == DEFAULT_ASSIGNMENT_OF_BENEFITS.toLowerCase()
        );

        patient_other_billing_details = {
            id: data.id ?? null,
            patient: data.patient ?? null,
            accident_date: data.accident_date ?? null,
            accident_location_id: data.accident_location ?? null,
            accident_type_id: data.accident_type ?? null,
            accept_assignments: data.accept_assignments ?? null,
            assignment_benefit_id: data.assignment_benefit ? data.assignment_benefit : obj.id ?? null,
            initial_treatment_date: data.initial_treatment_date ?? null,
            admission_date: data.admission_date ?? null,
            last_menstural_date: data.last_menstural_date ?? null,
            cliam_casuality_number: data.cliam_casuality_number ?? null,
            cpt1: data.cpt1 ?? null,
            cpt1List: data.cpt1 ? [{ id: data.cpt1, name: data.cpt1_name }] : [],
            cpt2: data.cpt2 ?? null,
            cpt2List: data.cpt2 ? [{ id: data.cpt2, name: data.cpt2_name }] : [],
            cpt3: data.cpt3 ?? null,
            cpt3List: data.cpt3 ? [{ id: data.cpt3, name: data.cpt3_name }] : [],
            cpt4: data.cpt4 ?? null,
            cpt4List: data.cpt4 ? [{ id: data.cpt4, name: data.cpt4_name }] : [],
            cpt5: data.cpt5 ?? null,
            cpt5List: data.cpt5 ? [{ id: data.cpt5, name: data.cpt5_name }] : [],
            cpt6: data.cpt6 ?? null,
            cpt6List: data.cpt6 ? [{ id: data.cpt6, name: data.cpt6_name }] : [],
            cpt7: data.cpt7 ?? null,
            cpt7List: data.cpt7 ? [{ id: data.cpt7, name: data.cpt7_name }] : [],
            cpt8: data.cpt8 ?? null,
            cpt8List: data.cpt8 ? [{ id: data.cpt8, name: data.cpt8_name }] : [],
            cpt9: data.cpt9 ?? null,
            cpt9List: data.cpt9 ? [{ id: data.cpt9, name: data.cpt9_name }] : [],
            cpt10: data.cpt10 ?? null,
            cpt10List: data.cpt10
                ? [{ id: data.cpt10, name: data.cpt10_name }]
                : [],
            cpt11: data.cpt11 ?? null,
            cpt11List: data.cpt11
                ? [{ id: data.cpt11, name: data.cpt11_name }]
                : [],
            cpt12: data.cpt12 ?? null,
            cpt12List: data.cpt12
                ? [{ id: data.cpt12, name: data.cpt12_name }]
                : [],
            dx1: data.dx1 ?? null,
            dx1List: data.dx1 ? [{ label: data.dx1, name: data.dx1_name }] : [],
            dx2: data.dx2 ?? null,
            dx2List: data.dx2 ? [{ label: data.dx2, name: data.dx2_name }] : [],
            dx3: data.dx3 ?? null,
            dx3List: data.dx3 ? [{ label: data.dx3, name: data.dx3_name }] : [],
            dx4: data.dx4 ?? null,
            dx4List: data.dx4 ? [{ label: data.dx4, name: data.dx4_name }] : [],
            dx5: data.dx5 ?? null,
            dx5List: data.dx5 ? [{ label: data.dx5, name: data.dx5_name }] : [],
            dx6: data.dx6 ?? null,
            dx6List: data.dx6 ? [{ label: data.dx6, name: data.dx6_name }] : [],
            dx7: data.dx7 ?? null,
            dx7List: data.dx7 ? [{ label: data.dx7, name: data.dx7_name }] : [],
            dx8: data.dx8 ?? null,
            dx8List: data.dx8 ? [{ label: data.dx8, name: data.dx8_name }] : [],
            dx9: data.dx9 ?? null,
            dx9List: data.dx9 ? [{ label: data.dx9, name: data.dx9_name }] : [],
            dx10: data.dx10 ?? null,
            dx10List: data.dx10 ? [{ label: data.dx10, name: data.dx10_name }] : [],
            dx11: data.dx11 ?? null,
            dx11List: data.dx11 ? [{ label: data.dx11, name: data.dx11_name }] : [],
            dx12: data.dx12 ?? null,
            dx12List: data.dx12 ? [{ label: data.dx12, name: data.dx12_name }] : [],
            other_accident: data.other_accident ?? null,
            permittedFields: {
                default_dx: permittedField?.default_dx,
                default_cpt: permittedField?.default_cpt, other_billing: permittedField?.other_billing_info
            } ?? {}
        }
    }
    return patient_other_billing_details;
}

export const checkFormWarning = (patientbasic, patient_info, patientFormWarnings, isInsurance = false) => {
    let formWarningsData;
    formWarningsData = patientFormWarnings.map((item) => ({ ...item }));
    if (patientbasic) {
        formWarningsData[0] = { ...formWarningsData[0], "Last Name": patientbasic?.last_name ?? "" };
        formWarningsData[0] = { ...formWarningsData[0], "First Name": patientbasic?.first_name ?? "" };
        formWarningsData[0] = { ...formWarningsData[0], Gender: patientbasic?.gender ?? "" };
        formWarningsData[0] = { ...formWarningsData[0], DOB: patientbasic?.date_of_birth ?? "" };
        formWarningsData[0] = { ...formWarningsData[0], "Patient Type": patientbasic?.patient_type ?? "" };
        if (patientbasic?.patient_type === 1) {
            if (!isInsurance) {
                formWarningsData[2] = { ...formWarningsData[2], "Insurance Details": "" };
            } else {
                formWarningsData[2] = { ...formWarningsData[2], "Insurance Details": "Insurance Exists" };
            }
        } else {

            formWarningsData[2] = { ...formWarningsData[2], "Insurance Details": "Mock value" };
        }

    }

    if (patient_info) {
        if (patient_info?.home_phone) {
            formWarningsData[1]["Home Phone"] = patient_info?.home_phone;
        }
        if (patient_info?.location_data) {
            formWarningsData[1]["Street1"] = patient_info?.location_data["street1"];
            formWarningsData[1]["City"] = patient_info?.location_data["city"];
            formWarningsData[1]["State"] = patient_info?.location_data["state"];
            formWarningsData[1]["Zip"] = patient_info?.location_data["zip_code"];
            formWarningsData[1]["Invalid Zip"] = (patient_info?.location_data?.zip_code?.length === 5) ? "false" : "";
        }
    }

    return formWarningsData;

}


const findDuplicates=(arr)=>{
    return arr.filter((item, index) => arr.indexOf(item) !== index);
}

/**
 * Validates CPT or DX codes ensuring there are no structural gaps 
 * (e.g., code 2 cannot be empty if code 3 is filled) and extracts lists for duplication checks.
 * * @param {string} codeType - Either "cpt" or "dx"
 * @param {Object} billingData - The source object containing keys like cpt1...cpt12 or dx1...dx12
 * @param {Function} findDuplicatesFn - Dependency-injected function to locate duplicate elements
 * @returns {Object} { validationMap, isValidated, codeList }
 */
export function validateCPTICDCodes(codeType, billingData) {
    const validationMap = {};
    let foundTopOrderValue = false;
    let isValidted = true;
    const codeList = [];
  
    // Initialize all 12 validation positions cleanly
    for (let cnt = 1; cnt <= 12; cnt++) {
      validationMap[`${codeType}${cnt}`] = "";
    }
  
    // Iterate backwards from 12 down to 1 to find gaps
    for (let dgCnt = 12; dgCnt > 0; dgCnt--) {
      const tmpName = `${codeType}${dgCnt}`;
      const value = billingData?.[tmpName];
  
      if (value !== undefined && value !== null && value !== "") {
        foundTopOrderValue = true;
        validationMap[tmpName] = "";
        codeList.push(parseInt(value, 10));
      } else if (foundTopOrderValue && (!value || value === "")) {
        // Gap discovered! (A higher order field was populated, but an interim one is missing)
        validationMap[tmpName] = " input-error";
        isValidted = false;
      } else if (!foundTopOrderValue) {
        validationMap[tmpName] = "";
      }
    }
    // Check for duplicates within populated metrics
    const duplicateElements = findDuplicates(codeList);
    const isDuplicated = duplicateElements.length > 0;
  
    return {
      validationMap,
      isValidted,
      isDuplicated,
    };
  }


// All claim sections that should be diffed together on a single update click.
export const CLAIM_SECTION_KEYS = [
    'patientBasicInfo',
    'patientInfoData',
    'otherBillingDetails',
];

/**
 * Fields that should always be skipped when diffing current vs. original data.
 * These are matched by key name at any nesting depth.
 *
 * Add generic, cross-section noise here (e.g. UI-only flags, server audit
 * fields). For section-specific ignores, pass a per-section map to
 * `buildAllChangedFieldsPayload` instead.
 */
export const DEFAULT_IGNORED_FIELDS = [
    "permittedFields"
];

/**
 * Ignored fields scoped to a specific section. Keys match section keys in
 * `CLAIM_SECTION_KEYS`; values are arrays of field names (matched at any depth)
 * that should be ignored only while diffing that section.
 */
export const SECTION_IGNORED_FIELDS = {
    patientBasicInfo: [
        "practice_details",
        "patient_type_details",
        "detail_ids",
        "locked_by_name",
        "created_on",
        "custom_patient_id",
        "locked",
        "unid",
        "no_of_statement_sent",
        "last_statement_date",
        "cmd_patient_code",
        "external_mrn",
        "locked_by",
    ],
    patientInfoData: [

    ],
    otherBillingDetails: [

    ]
};

const toIgnoreSet = (ignoreFields) => {
    if (!ignoreFields) return null;
    if (ignoreFields instanceof Set) {
        return ignoreFields.size ? ignoreFields : null;
    }
    if (Array.isArray(ignoreFields) && ignoreFields.length) {
        return new Set(ignoreFields);
    }
    return null;
};

/**
 * Deep-diff between a current value and its original (duplicate) value.
 * Returns:
 *  - `undefined` when there is no change
 *  - the new value (or a partial object containing only changed keys) otherwise
 *
 * Behaviour notes:
 *  - Plain objects are diffed key by key, returning only the changed keys
 *    (preserving the original data shape for those keys).
 *  - Arrays are treated as atomic: if any element differs (or length differs),
 *    the entire new array is returned. This keeps payloads predictable when
 *    sending lists like `procedures`, `payer_info`, etc. to the backend.
 *    Ignored fields are still honoured for elements that are plain objects,
 *    so arrays-of-objects won't report a change caused solely by ignored keys.
 *  - `null` / `undefined` are treated as equivalent only when both sides are nullish.
 *  - `ignoreFields` (Set | Array of strings) skips keys by name at ANY depth.
 */
const getChangedFields = (current, original, ignoreFields) => {
    const ignoreSet = ignoreFields instanceof Set ? ignoreFields : toIgnoreSet(ignoreFields);

    if (current === original) return undefined;
    if (current == null && original == null) return undefined;
    if (current == null || original == null) return current;

    if (Array.isArray(current) || Array.isArray(original)) {
        if (!Array.isArray(current) || !Array.isArray(original)) return current;

        const changedElements = current.map((item, index) => {
            const originalItem = original[index];

            if (originalItem === undefined) return item;

            const itemDiff = getChangedFields(item, originalItem, ignoreSet);

            if (itemDiff !== undefined && typeof item === 'object' && item !== null) {
                return {
                    ...(item.id ? { id: item.id } : {}),
                    ...(item.pk ? { pk: item.pk } : {}),
                    ...itemDiff
                };
            }

            if (itemDiff !== undefined && typeof item !== 'object') return item;

            return undefined;
        }).filter(item => item !== undefined);

        return (changedElements.length > 0 || current.length < original.length)
            ? changedElements
            : undefined;
    }

    if (typeof current === 'object' && typeof original === 'object') {
        const changes = {};
        const keys = new Set([...Object.keys(current), ...Object.keys(original)]);
        let hasChanges = false;

        keys.forEach((key) => {
            if (ignoreSet && ignoreSet.has(key)) return;

            const childChange = getChangedFields(current[key], original[key], ignoreSet);
            if (childChange !== undefined) {
                changes[key] = childChange;
                hasChanges = true;
            }
        });
        return hasChanges ? changes : undefined;
    }

    return current !== original ? current : undefined;
};

/**
 * Compute the diff for a single section against its snapshot in `duplicateDataSet`.
 * Returns the changed-fields object for that section, or `null` if nothing changed.
 *
 * `ignoreFields` (Set | Array of strings) is applied in addition to
 * `DEFAULT_IGNORED_FIELDS` and any entry in `SECTION_IGNORED_FIELDS[sectionKey]`.
 */
const getSectionChanges = (sectionKey, patientbeta, ignoreFields) => {
    const currentData = patientbeta?.[sectionKey];
    const originalData = patientbeta?.duplicateDataSet?.[sectionKey];

    if (!currentData || !originalData) return null;

    const mergedIgnore = new Set([
        ...DEFAULT_IGNORED_FIELDS,
        ...(SECTION_IGNORED_FIELDS[sectionKey] || []),
        ...(Array.isArray(ignoreFields) ? ignoreFields : []),
        ...(ignoreFields instanceof Set ? ignoreFields : []),
    ]);

    const changed = getChangedFields(currentData, originalData, mergedIgnore);
    if (!changed || (typeof changed === 'object' && Object.keys(changed).length === 0)) {
        return null;
    }
    return changed;
};

/**
 * Compute changed fields for every claim section in one pass.
 *
 * Output shape:
 *   {
 *     patientBasicInfo: { ...changedFieldsOnly },
 *     patientInfoData:       { ...changedFieldsOnly },
 *     otherBillingDetails:       { ...changedFieldsOnly }
 *   }
 *
 * Sections without any change are omitted from the result.
 *
 * @param {object} patientbeta  Current redux slice (must contain `duplicateDataSet`).
 * @param {string|string[]} sectionKeys  Section key(s) to diff.
 * @param {string[] | Set<string> | Object<string, string[]>} [ignoreFields]
 *   Extra fields to skip while diffing. Pass an array/Set to apply globally,
 *   or an object `{ [sectionKey]: [...] }` to apply per-section.
 */
export const buildAllChangedFieldsPayload = (
    patientbeta,
    sectionKeys = CLAIM_SECTION_KEYS,
    ignoreFields
) => {
    const keys = Array.isArray(sectionKeys) ? sectionKeys : [sectionKeys];
    const isPerSectionMap =
        ignoreFields && !Array.isArray(ignoreFields) && !(ignoreFields instanceof Set)
        && typeof ignoreFields === 'object';

    let result = {};
    keys.forEach((key) => {
        const perSection = isPerSectionMap ? ignoreFields[key] : ignoreFields;
        const sectionChanges = getSectionChanges(key, patientbeta, perSection);
        if (sectionChanges) {
            result = sectionChanges;
        } else {
            result = {};
        }
    });
    return { [sectionKeys]: result };
};

export function validatePatientData(patientBasicInfo, patientInfoData, otherBillingDetails, renderingProvider) {
    let patientAddVariables = patientBasicInfo;
    const accidentDate = otherBillingDetails?.accident_date;
    const admissionDate = otherBillingDetails.admission_date;
    const initialTreatmentDate = otherBillingDetails?.initial_treatment_date;
    const lastMensturalDate = otherBillingDetails?.last_menstural_date;

    // 1. Death Date Validation
    let deathDate = null;
    if (patientAddVariables?.date_of_death) {
        deathDate = format(patientAddVariables.date_of_death, "yyyy-MM-dd");
    }

    if (deathDate) {
        if (
            (initialTreatmentDate && initialTreatmentDate > deathDate) ||
            (admissionDate && admissionDate > deathDate) ||
            (accidentDate && accidentDate > deathDate) ||
            (lastMensturalDate && lastMensturalDate > deathDate)
        ) {
            return {
                isValid: false,
                message: "commons.deathDateValidation" // i18n key
            };
        }
    }

    // 2. Location & Provider Validation
    const locationData = patientInfoData?.location_data;
    const providerId = patientInfoData?.rendering_provider;

    if (locationData) {
        const { street1, city, state, zip_code } = locationData;
        if (!street1 || !city || !state || !zip_code || !providerId) {
            return {
                isValid: false,
                message: ""
            };
        }
    }

    // 3. Rendering Provider Fallback and Custom ValidateError check
    const renderingProviderId = patientInfoData?.rendering_provider ||
        (renderingProvider && renderingProvider.length > 0 ? renderingProvider[0].id : "");

    // Simulating your custom ValidateError logic
    if (!renderingProviderId || renderingProviderId === "INVALID") {
        return {
            isValid: false,
            message: ""
        };
    }

    return { isValid: true, renderingProviderId };
}


const validateEmailFormat = (email) => {
    if (!email) return true;
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
};

export const patientValidationMiddleware = (
    patientBasicInfo, patientInfoData,pk, diagnosisesValidated, 
    cptduplicated, cptValidated,diagnosisduplicated,renderingProvider) => {
    let patientInfoValidEmail = false;
    let patientInfoValidGuarantorEmail = false;
    let patientInfoValidEmergencyEmail = false;
    let isError = false;
    let errorMessage = ""

    const rendering_provider_id = patientInfoData?.rendering_provider ||
    (renderingProvider && renderingProvider.length > 0 ? renderingProvider[0].id : "");

    if (
        (pk && !rendering_provider_id) ||
        !patientBasicInfo.last_name ||
        !patientBasicInfo.first_name ||
        !patientBasicInfo.gender ||
        !patientBasicInfo.patient_type ||
        !patientBasicInfo.date_of_birth
    ) {
        isError = true;
        errorMessage = i18n.t("patientbeta.api_error.mandatory_field_missing")
    }


    if (patientInfoData.email) {
        if (!validateEmailFormat(patientInfoData.email)) {
            patientInfoValidEmail = true;
            isError = true;
            errorMessage = ""
        }
    }
    if (patientInfoData.guarantor_email) {
        if (!validateEmailFormat(patientInfoData.guarantor_email)) {
            patientInfoValidGuarantorEmail = true;
            isError = true;
            errorMessage = ""
        }
    }
    if (patientInfoData.emergency_email) {
        if (!validateEmailFormat(patientInfoData.emergency_email)) {
            isError = true;
            errorMessage = ""
            patientInfoValidEmergencyEmail = true
        }
    }

    if (
        patientBasicInfo.ssn &&
        patientBasicInfo.ssn.length !== SSN_VALID_LENGTH &&
        patientBasicInfo.ssn.length !== SSN_VALID_LENGTH_SMALL
    ) {
        isError = true;
        errorMessage = ""
    }

    if (diagnosisduplicated) {
        isError = true;
        errorMessage = i18n.t("errorMessages.duplicate_diagnosis_item")
    }

    if (!diagnosisesValidated) {
        isError = true;
        errorMessage = i18n.t("errorMessages.invalid_diagonsis_order")
    }

    if (cptduplicated) {
        isError = true;
        errorMessage = i18n.t("errorMessages.duplicate_cpt_item")
    }
    if (!cptValidated) {
        isError = true;
        errorMessage = i18n.t("errorMessages.invalid_cpt_codes")
    }
    return { isError, errorMessage, patientInfoValidEmail, patientInfoValidEmergencyEmail, patientInfoValidGuarantorEmail }

}
const nullifyEmptyStrings = (obj) => {
    if (obj === null || obj === undefined) return obj;
    
    if (Array.isArray(obj)) {
        return obj.map(item => (typeof item === 'object' ? nullifyEmptyStrings(item) : item));
    }
    
    if (typeof obj === 'object') {
        const cleanedObj = {};
        for (const [key, value] of Object.entries(obj)) {
            if (value === "") {
                cleanedObj[key] = null;
            } else if (typeof value === 'object') {
                cleanedObj[key] = nullifyEmptyStrings(value);
            } else {
                cleanedObj[key] = value;
            }
        }
        return cleanedObj;
    }
    
    return obj;
};

export const createPatientSaveData = (patientBasicInfoData, patientInfo, otherBillingData,renderingProvider,patientBasicInfo) => {
    const isPatientBasicDataEmpty = Object.keys(patientBasicInfoData || {}).length === 0;
    const isPatientInfoDataEmpty = Object.keys(patientInfo || {}).length === 0;
    const isOtherBillingDataEmpty = Object.keys(otherBillingData || {}).length === 0;

    // If absolutely nothing changed across all blocks, return an empty object or null
    if (isPatientBasicDataEmpty && isPatientInfoDataEmpty && isOtherBillingDataEmpty) {
        return {};
    }

    let data = {};

    // --- 1. Handle Patient Basic Info (Only if changes exist) ---
    if (!isPatientBasicDataEmpty) {
        let {
            first_name,
            middle_name,
            last_name,
            suffix,
            gender,
            date_of_birth,
            date_of_death,
            patient_type,
            ssn,
            other_id,
        } = patientBasicInfoData;

        // Reconstruct only the keys that were actually passed in
        if (first_name !== undefined) data.first_name = first_name;
        if (middle_name !== undefined) data.middle_name = middle_name;
        if (last_name !== undefined) data.last_name = last_name;
        if (suffix !== undefined) data.suffix = suffix;
        if (gender !== undefined) data.gender = gender;
        if (patient_type !== undefined) data.patient_type = patient_type;
        if (ssn !== undefined) data.ssn = ssn;
        if (other_id !== undefined) data.other_id = other_id;

        // Handle date formatting safely if they were part of the changes
        if (date_of_birth !== undefined) {
            data.date_of_birth = date_of_birth ? format(new Date(date_of_birth), "yyyy-MM-dd") : null;
        }
        if (date_of_death !== undefined) {
            data.date_of_death = date_of_death ? format(new Date(date_of_death), "yyyy-MM-dd") : null;
        }

        if (patientBasicInfoData?.patient_inactive) {
            data.active = !patientBasicInfoData.patient_inactive;
        }
    }

    // --- 2. Handle Patient Info Block (Only if changes exist) ---
    if (!isPatientInfoDataEmpty) {
        let patientInfoData = {};

        // Keep your original validation logic intact
        if (patientInfo.location?.street1?.length > 0 && patientInfo?.location?.zip_code?.length > 0) {
            patientInfoData = { ...patientInfo };
        } else {
            // Build object fallback from Redux state (or whatever global scope source you used)
            // We wrap these in undefined checks so we ONLY send keys that actually changed in Redux
            const appendIfDefined = (target, sourceKey, targetKey) => {
                if (patientInfo?.[sourceKey] !== undefined) {
                    target[targetKey] = patientInfo[sourceKey];
                }
            };

            appendIfDefined(patientInfoData, 'guarantor_relationship', 'guarantor_relationship_id');
            appendIfDefined(patientInfoData, 'emergency_relationship', 'emergency_relationship_id');
            appendIfDefined(patientInfoData, 'authorized_contact', 'authorized_contact');

            // Helper to dynamically build nested location blocks only if they contain data
            const buildLocationKeys = (prefix) => {
                const locData = {};
                // Determine the source key in patientInfo (e.g., 'guarantor_location_data' or 'location_data')
                const sourcePrefix = prefix ? `${prefix}_location_data` : 'location_data';
                
                // Determine the output prefix for your flat keys (e.g., 'guarantor_location')
                const outputPrefix = prefix ? `${prefix}_location` : 'location';
            
                if (patientInfo?.[sourcePrefix]) {
                    ['street1', 'street2', 'zip_code', 'city', 'state', 'country'].forEach(field => {
                        if (patientInfo[sourcePrefix][field] !== undefined) {
                            // Dynamically create flat keys like 'guarantor_location_city'
                            locData[`${outputPrefix}_${field}`] = patientInfo[sourcePrefix][field];
                        }
                    });
                }
                
                // Returns the flat object if it has data, otherwise undefined
                return Object.keys(locData).length > 0 ? locData : undefined;
            };
            
            // 1. Get the flat location objects
            const primaryLoc = buildLocationKeys('');
            const guarantorLoc = buildLocationKeys('guarantor');
            const emergencyLoc = buildLocationKeys('emergency');
            
            // 2. Spread them directly into patientInfoData to keep them as separate, top-level keys
            if (primaryLoc) {
                Object.assign(patientInfoData, primaryLoc);
            }
            
            if (guarantorLoc) {
                Object.assign(patientInfoData, guarantorLoc);
            }
            
            if (emergencyLoc) {
                Object.assign(patientInfoData, emergencyLoc);
            }

            // Plain phone/email/meta fields
            const simpleFields = [
                'cell_phone', 'work_phone', 'home_phone', 'guarantor_work_phone',
                'guarantor_cell_phone', 'emergency_home_phone', 'emergency_work_phone',
                'emergency_cell_phone', 'email', 'ethnicity', 'race', 'guarantor_last_name',
                'guarantor_first_name', 'guarantor_middle_name', 'guarantor_home_phone',
                'guarantor_email', 'emergency_last_name', 'emergency_first_name',
                'emergency_middle_name', 'emergency_suffix', 'emergency_email',
                'emergency_as_guarantor', 'guarantor_address_as_patient', 'guarantor_suffix', 'active'
            ];

            simpleFields.forEach(field => appendIfDefined(patientInfoData, field, field));

            // Custom Mapping IDs
            appendIfDefined(patientInfoData, 'preferred_language', 'preferred_language_id');
            appendIfDefined(patientInfoData, 'rendering_provider', 'rendering_provider_id');
            appendIfDefined(patientInfoData, 'referring_provider', 'referring_provider_id');
            appendIfDefined(patientInfoData, 'referring_provider_group', 'referring_provider_group_id');

            // Service location splitting logic
            if (patientInfo?.service_location_value) {
                const parts = patientInfo.service_location_value.split("||");
                patientInfoData.service_location = {
                    id: parts[0],
                    location_type: parts[1]
                };
            }
        }
        // Only add patient_info property if it wound up with keys inside it
        if (Object.keys(patientInfoData).length > 0) {
            data.patient_info = patientInfoData;
            if (patientBasicInfo?.detail_ids) {
                data.patient_info["pk"] = patientBasicInfo.detail_ids.patient_info;
            }
        }
    }

    // --- 3. Handle Billing Info Block (Only if changes exist) ---
    if (!isOtherBillingDataEmpty) {
        data.billing_info = otherBillingData;
        if (patientBasicInfo?.detail_ids) {
            data.billing_info["pk"] = patientBasicInfo.detail_ids.billing_info;
        }
    }

    const finalPayload = { ...data, practice: getStorage('practice') };

    return nullifyEmptyStrings(finalPayload);
};